import { Weekday } from '@/domain/dienstplan/shared/types/Weekday';
import { Dienstplan_Tag } from '@/gql/graphql';

// eslint-disable-next-line complexity
export function mapWochentagForAPI(tag: Weekday): Dienstplan_Tag {
  if (tag === 'montag') {
    return Dienstplan_Tag.Montag;
  }
  if (tag === 'dienstag') {
    return Dienstplan_Tag.Dienstag;
  }
  if (tag === 'mittwoch') {
    return Dienstplan_Tag.Mittwoch;
  }
  if (tag === 'donnerstag') {
    return Dienstplan_Tag.Donnerstag;
  }
  if (tag === 'freitag') {
    return Dienstplan_Tag.Freitag;
  }
  if (tag === 'samstag') {
    return Dienstplan_Tag.Samstag;
  }
  if (tag === 'sonntag') {
    return Dienstplan_Tag.Sonntag;
  }
  return Dienstplan_Tag.Feiertag;
}
